import { type CarouselItem } from '../../respMarketplace/PdpRespHeroCarousel/types.ts';

export const getMediaCountsFromCarouselItems = (
    carouselItems: CarouselItem[]
): { photoCount: number; hasVideo: boolean } => {
    let photoCount = 0;
    let hasVideo = false;

    for (const item of carouselItems) {
        if (item.__type === 'photo' || item.__type === 'viewInRoom') {
            photoCount += 1;
        } else if (item.__type === 'video') {
            hasVideo = true;
        }
    }

    return { photoCount, hasVideo };
};

export const getMobileMediaCounts = ({
    photoCount,
    viewInRoomCount = 0,
    hasVideo = false,
}: {
    photoCount: number;
    viewInRoomCount?: number;
    hasVideo?: boolean;
}): { photoCount: number; hasVideo: boolean } => ({
    photoCount: photoCount + viewInRoomCount,
    hasVideo,
});
